// src/assets/roomBackgrounds.js
const roomBackgrounds = {
  ElectricBlue: "/backgrounds/ElectricBlue.webp",
  Flowsniggle: "/backgrounds/Flowsniggle.webp",
  Foxmantle: "/backgrounds/Foxmantle.webp",
  Furiously_Eclectic: "/backgrounds/Traveller.webp",
  Guildhall: "/backgrounds/Guildhall.webp",
  Jurus: "/backgrounds/Jurus.webp",
  Kakov: "/backgrounds/Kakov.webp",
  Kuniaman: "/backgrounds/Kuniaman.webp",
  MacQuade: "/backgrounds/MacQuade.webp",
  Illusion_Horror: "/backgrounds/Necryl.webp",
  Oakleaf: "/backgrounds/Oakleaf.webp",
  Payroll: "/backgrounds/Payroll.webp",
  Plumber: "/backgrounds/Plumber.webp",
  Quadros: "/backgrounds/Quadros.webp",
  Silvermoon: "/backgrounds/Silvermoon.webp",
  Sultanovich: "/backgrounds/Sultanovich.webp",
  Takesane: "/backgrounds/Takesane.webp",
  Teacups: "/backgrounds/Teacups.webp",
  Truthseeker: "/backgrounds/Truthseeker.webp",
  Vorcoth: "/backgrounds/Vorcoth.webp",
  Ziska_Simons: "/backgrounds/Ziska_Simons.webp",
  Default: "/backgrounds/dice-bg.jpeg",
  Mobile: "/backgrounds/MobileBG.webp",
};

export default roomBackgrounds;